import apiWrapper, { getMethod } from './helpers'

export default class GlobalTransfer extends apiWrapper('/global_transfers') {
  static balances = getMethod('/global_transfers/balances')
}
